// NoRecords.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const NoRecords = () => {
    const { t } = useTranslation();

    return (
        <tr>
            <td
                colSpan='9'
                style={{
                    textAlign: 'center',
                    padding: '100px',
                    marginTop: '200px',
                    fontSize: '15px'
                }}
            >
                <svg
					width='40'
					height='40'
					viewBox='0 0 24 24'
					fill='none'
					stroke='currentColor'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'>
					<circle cx='11' cy='11' r='8' />
					<path d='M21 21l-4.35-4.35' />
				</svg>
				<br />
				<br />
                {t('There are no available records')}
                {/* {t('There are no available records')} */}
            </td>
        </tr>
    );
};

export default NoRecords;